import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ShHtmlParserComponent } from '../core/html-parser/html-parser.component';
import { ShIconModule } from '../elements/components/icon/icon.module';

import { ShToastComponent } from './components/toast/toast.component';
import { ShToastContainerComponent } from './containers/toast-container/toast-container.component';

@NgModule({
    imports: [CommonModule, RouterModule, ShIconModule, ShHtmlParserComponent, ShToastComponent, ShToastContainerComponent],
    exports: [ShToastComponent, ShToastContainerComponent]
})
export class ShToastModule {}

export * from './entities/toast.entity';
export * from './factories/toast.factory';
export * from './helpers/generic-action-toast.helper';
export * from './services/toast.abstract.service';
